import { msg } from "@lingui/core/macro";

export const durationMaximumRuleMessages = {
	name: msg({ message: "Duration Maximum" }),
	description: msg({ message: "Permit can only exist for a maximum duration" }),
	errors: {
		tooLong: msg({
			message: "Permit must have a duration shorter than 10 years. For perpetual permits, use an empty end date.",
		}),
	},
} as const;
